/* eslint-disable no-undef */
import $ from "jquery";

class NavbarMobile {
    // 1. describe and create/initiate our object
    constructor() {
        this.btnNavOpen = $(`.js-navbar-open`);
        this.btnNavClose = $(`.js-navbar-close`);
        this.navbar = $(`.header-nav-mobile .nav`);

        this.events();
    }

    // 2. events
    events() {
        if (this.btnNavOpen.length > 0) {
            $(this.btnNavOpen).click(this.handlOpenNavbar.bind(this));
        }

        if (this.btnNavClose.length > 0) {
            $(this.btnNavClose).click(this.handleCloseNavbar.bind(this));
        }
    }

    // 3. methods (function, action...)
    handlOpenNavbar(e) {
        e.preventDefault();
        this.navbar.addClass("active");
    }

    handleCloseNavbar(e) {
        e.preventDefault();
        this.navbar.removeClass("active");
    }
}

export default NavbarMobile;
